<template>
    <Paper :header="$t('spotlight.education.header')" tall>
        <EducationSkeleton v-if="isLoading" />
        <div v-else class="p-4 grid">
            <EducationItem
                v-for="(e, i) in degrees"
                :key="i"
                class="mb-3"
                :school="e.school"
                :degree="e.name"
                :graduationDate="e.end"
                :logo="e.logo"
                :field="e.field_id"
                :level="e.level_id"
                :state="e.enumKey"
                v-on:onEdit="() => onEdit(e)"
            />
            <BaseButton variant="outline-secondary" @click="openModal">
                {{ $t('spotlight.education.addEducation') }}
            </BaseButton>
        </div>
        <!-- <EducationModal
            :show="showModal"
            v-on:close="toggleModal"
            v-on:create="onCreate"
            v-on:save="onSave"
            v-on:delete="onDelete"
            :degree="selectedDegree"
        /> -->
    </Paper>
</template>

<script>
// Component specific components
import EducationItem from './EducationItem';
import EducationSkeleton from '../skeletons/EducationSkeleton';

// Utils
import DialogService from '~/services/DialogService';
import hasDegreeChanged from '~/utils/degrees/hasDegreeChanged';
import StateEnum from '~/utils/StateEnum';
import uuidv4 from '~/utils/uuidv4';

export default {
    name: 'Education',
    components: { EducationItem, EducationSkeleton },
    props: {
        value: {
            // Educations
            type: Array,
            default: () => [],
        },
        oldDegrees: {
            type: Array,
            default: () => [],
        },
        isLoading: Boolean,
    },
    data: () => ({
        reloadKey: uuidv4(),
        selectedDegree: null,
        shouldUpdateDegrees: true,
    }),
    computed: {
        degrees() {
            if (this.shouldUpdateDegrees) {
                this.shouldUpdateDegrees = false;
            }

            // Checks if a degree has been changed or not (is for EducationItem)
            const degrees = this.value;

            if (!this.oldDegrees) {
                return degrees;
            }

            degrees.forEach(d => {
                const hasChanged = hasDegreeChanged(d, this.oldDegrees);
                d.enumKey = hasChanged ? StateEnum.UNSAVED : StateEnum.SUCCESS;
            });
            return degrees;
        },
    },
    methods: {
        openModal() {
            DialogService.openEducationDialog(
                {
                    degree: this.selectedDegree,
                },
                {
                    create: this.onCreate,
                    save: this.onSave,
                    delete: this.onDelete,
                    close: this.onClose,
                }
            );
        },
        indicateDataChanged() {
            this.$emit('change');
        },
        onClose() {
            this.selectedDegree = null;
        },
        onCreate(data) {
            if (data.school) {
                data.school.name = data.school.label;
            }
            this.$emit('input', [...this.value, data]);
        },
        onSave(data) {
            if (data.school) {
                data.school.name = data.school.name || data.school.label;
            }

            // Find degree by id
            const degrees = this.value;
            let index = degrees.findIndex(d => d.id === data.id);
            if (index === -1) {
                return;
            }

            // Change data
            let degree = degrees[index];
            degree = { ...degree, ...data };
            degrees[index] = degree;

            //Force degree update
            this.shouldUpdateDegrees = true;

            // Emit
            this.$emit('input', degrees);
            this.indicateDataChanged();
        },
        onEdit(degree) {
            this.selectedDegree = degree;
            this.openModal();
        },
        onDelete(id) {
            // Deletes a degree
            const degrees = this.value;
            const index = degrees.findIndex(d => d.id === id);
            if (index !== -1) {
                degrees.splice(index, 1);
                this.$emit('input', degrees);
            }
        },
    },
};
</script>

<style scoped>
.grid {
    display: grid;
    grid-auto-rows: auto;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
}
</style>
